document.addEventListener('DOMContentLoaded', () => {
  const STORAGE_KEY = 'pag_header_video_experiment_v1';
  const VIDEO_AD_EXCLUSION_KEY = 'pag_video_ad_excluded_v1';

  const wrapper = document.getElementById('pag-welcome');
  const video = document.getElementById('pag-welcome-video');

  const params = new URLSearchParams(window.location.search);
  const forcedVariant = params.get('pag_test');
  const currentSource = params.get('pag_source');

  function getStoredVariant() {
    try {
      const value = localStorage.getItem(STORAGE_KEY);

      if (value === 'control' || value === 'video') {
        return value;
      }
    } catch (error) {}

    return null;
  }

  function storeVariant(variant) {
    try {
      localStorage.setItem(STORAGE_KEY, variant);
    } catch (error) {}
  }

  function isVideoAdExcluded() {
    if (currentSource === 'video_ad') {
      try {
        localStorage.setItem(VIDEO_AD_EXCLUSION_KEY, '1');
      } catch (error) {}

      return true;
    }

    /*
      Development override:
      pag_test=control or pag_test=video can still be used to test
      either experiment treatment even in a browser that has previously
      been marked as a video-ad visitor.
    */
    if (forcedVariant === 'control' || forcedVariant === 'video') {
  try {
    localStorage.removeItem(VIDEO_AD_EXCLUSION_KEY);
    localStorage.setItem(STORAGE_KEY, forcedVariant);
  } catch (error) {}

  return false;
}

    try {
      return localStorage.getItem(VIDEO_AD_EXCLUSION_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  const videoAdExcluded = isVideoAdExcluded();

  function getExperimentVariant() {
    if (videoAdExcluded) {
      return null;
    }

    if (forcedVariant === 'control' || forcedVariant === 'video') {
      return forcedVariant;
    }

    const storedVariant = getStoredVariant();

    if (storedVariant) {
      return storedVariant;
    }

    const variant = Math.random() < 0.5 ? 'control' : 'video';
    storeVariant(variant);

    return variant;
  }

  const experimentVariant = getExperimentVariant();

  /*
    Meta video-ad visitors are excluded from the experiment,
    but their displayed banner is the normal Control/EU banner.
  */
  const displayVariant = videoAdExcluded
    ? 'control'
    : experimentVariant;

  document.querySelectorAll('[data-pag-variant]').forEach((banner) => {
    banner.hidden = banner.dataset.pagVariant !== displayVariant;
  });

  function publishEvent(eventName, eventData = {}) {
    const payload = {
      experiment: 'pag_header_video_v1',
      variant: videoAdExcluded ? 'video_ad' : experimentVariant,
      ...eventData
    };

    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    ) {
      Shopify.analytics.publish(eventName, payload);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...payload
    });
  }

  if (videoAdExcluded) {
    publishEvent('pag_video_ad_visitor', {
      page_path: window.location.pathname
    });
  } else {
    publishEvent('pag_video_experiment_exposure', {
      page_path: window.location.pathname
    });
  }

  if (!wrapper || !video) return;

  const closeButton = wrapper.querySelector('.pag-welcome__close');
  const soundButton = wrapper.querySelector('.pag-welcome__sound');
  const replayButton = wrapper.querySelector('.pag-welcome__replay');
  const backdrop = wrapper.querySelector('.pag-welcome__backdrop');

  let started = false;
  const milestonesReached = new Set();

  function openWelcome() {
    wrapper.hidden = false;
    wrapper.setAttribute('aria-hidden', 'false');

    video.muted = true;
    video.currentTime = 0;

    soundButton.querySelector(
      '.pag-welcome__sound-icon--muted'
    ).style.display = 'block';

    soundButton.querySelector(
      '.pag-welcome__sound-icon--on'
    ).style.display = 'none';

    soundButton.setAttribute('aria-label', 'Turn sound on');

    replayButton.hidden = true;
    started = false;
    milestonesReached.clear();

    publishEvent('pag_video_invitation_clicked', {
      page_path: window.location.pathname
    });

    video.play().catch(() => {});
  }

  function closeWelcome() {
    const percentWatched =
      video.duration > 0
        ? Math.round((video.currentTime / video.duration) * 100)
        : 0;

    publishEvent('pag_video_closed', {
      percent_watched: percentWatched
    });

    video.pause();
    wrapper.hidden = true;
    wrapper.setAttribute('aria-hidden', 'true');
  }

  function toggleSound() {
    video.muted = !video.muted;

    const mutedIcon = soundButton.querySelector(
      '.pag-welcome__sound-icon--muted'
    );

    const soundOnIcon = soundButton.querySelector(
      '.pag-welcome__sound-icon--on'
    );

    if (video.muted) {
      mutedIcon.style.display = 'block';
      soundOnIcon.style.display = 'none';
      soundButton.setAttribute('aria-label', 'Turn sound on');
    } else {
      mutedIcon.style.display = 'none';
      soundOnIcon.style.display = 'block';
      soundButton.setAttribute('aria-label', 'Turn sound off');

      publishEvent('pag_video_sound_on');
    }
  }

  function replayVideo() {
    video.currentTime = 0;
    replayButton.hidden = true;
    started = false;
    milestonesReached.clear();

    publishEvent('pag_video_replayed');

    video.play();
  }

  document.querySelectorAll('[data-pag-video-open]').forEach((button) => {
    button.addEventListener('click', openWelcome);
  });

  closeButton?.addEventListener('click', closeWelcome);
  backdrop?.addEventListener('click', closeWelcome);
  soundButton?.addEventListener('click', toggleSound);
  replayButton?.addEventListener('click', replayVideo);

  video.addEventListener('play', () => {
    if (!started) {
      started = true;
      publishEvent('pag_video_started');
    }
  });

  video.addEventListener('timeupdate', () => {
    if (!video.duration) return;

    const percent = (video.currentTime / video.duration) * 100;

    [25, 50, 75].forEach((milestone) => {
      if (
        percent >= milestone &&
        !milestonesReached.has(milestone)
      ) {
        milestonesReached.add(milestone);

        publishEvent('pag_video_progress', {
          percent: milestone
        });
      }
    });
  });

  video.addEventListener('ended', () => {
    replayButton.hidden = false;
    publishEvent('pag_video_completed');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !wrapper.hidden) {
      closeWelcome();
    }
  });
});